import headers from "app/requests/headers";

export const destroy = () => (
  fetch("/api/store/cart", {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const update = (params) => (
  fetch("/api/store/cart", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);
